import React, { useRef, useEffect, useState, useCallback } from "react";
import Papa from "papaparse";
import { alpha } from "@mui/material/styles";
import makeStyles from "@mui/styles/makeStyles";
import AppBar from "@mui/material/AppBar";
import CssBaseline from "@mui/material/CssBaseline";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ListItem from "@mui/material/ListItem";
import MenuIcon from "@mui/icons-material/Menu";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import SearchIcon from "@mui/icons-material/Search";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Autocomplete, { createFilterOptions } from "@mui/material/Autocomplete";
import Grid from "@mui/material/Grid";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import LinearProgress from "@mui/material/LinearProgress";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import Paper from "@mui/material/Paper";
import Fab from "@mui/material/Fab";
import AddIcon from "@mui/icons-material/Add";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import CreateEditProduct from "./CreateEditProduct";
import { CSVLink, CSVDownload } from "react-csv";
import List from "@material-ui/core/List";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@mui/material/Divider";
import { createTheme } from "@mui/material";

import { ThemeProvider, StyledEngineProvider } from "@mui/material/styles";

import axios from "axios";

const drawerWidth = 300;
const materialTheme = createTheme({
  // set default for now
});
const filter = createFilterOptions();
const useStyles = makeStyles((theme) => ({
  appBarSpacer: theme.mixins.toolbar,

  appBarReviewOrder: {
    position: "fixed",
  },
  appBarBottomReviewOrder: {
    top: "auto",
    bottom: 0,
  },
  titleBarReviewOrder: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
  appBarTop: {
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  text: {
    padding: theme.spacing(2, 2, 0),
  },
  paper: {
    paddingBottom: 50,
  },
  list: {
    marginBottom: theme.spacing(2),
  },
  subheader: {
    backgroundColor: theme.palette.background.paper,
  },
  appBarBottom: {
    top: "auto",
    bottom: 0,
    [theme.breakpoints.up("sm")]: {
      width: `calc(100% - ${drawerWidth}px)`,
      marginLeft: drawerWidth,
    },
  },
  grow: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      marginLeft: theme.spacing(3),
      width: "auto",
    },
  },
  menu: {
    boxShadow: "0px 1px 5px rgba(0, 0, 0, 0.1)", // Override the box-shadow here
  },
}));

export default function Ordering(props) {
  const classes = useStyles();
  const [searchProductTerm, setSearchProductTerm] = useState({ name: "" });
  const [, setAppBarWidth] = useState(0);
  const elementRef = useRef(null);
  const [, setAnchorEl] = useState(null);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const openMenu = Boolean(menuAnchorEl);
  const [autoSuggestProducts, setAutoSuggestProducts] = useState([]);
  const [products, setProducts] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [showMessageDialog, setShowMessageDialog] = useState(false);
  const [showCsvMessageDialog, setShowCsvMessageDialog] = useState(false);
  const [autoCompleteSearchOptionMessage, setAutoCompleteSearchOptionMessage] =
    useState("Searching...");
  const [messageDialogMessage, setMessageDialogMessage] = useState("");
  const [hasErrorFetchingProducts, setHasErrorFetchingProducts] = useState(false);
  const [hasMoreProductToLoad, setHasMoreProductToLoad] = useState(true);
  const [pageNumber, setPageNumber] = useState(1);
  const [loadProducts, setLoadProducts] = useState(true);

  const [showUploadProductsDialog, setShowUploadProductsDialog] = useState(false);
  const [showUploadProductStatusDialog, setShowUploadProductStatusDialog] = useState(false);
  const [csvUploadPercent, setCsvUploadPercent] = useState(0);
  const [showUploadProductCategoriesListDialog, setShowUploadProductCategoriesListDialog] =
    useState(false);
  const [productCategoriesList, setProductCategoriesList] = useState([]);

  const [showUpdatePriceDialog, setShowUpdatePriceDialog] = useState(false);
  const [showUpdatePriceStatusDialog, setShowUpdatePriceStatusDialog] = useState(false);
  const [uploadStatusArray, setUploadStatusArray] = useState([]);
  const [csvDownloadPercent, setCsvDownloadPercent] = useState(0);
  const [csvFile, setCsvFile] = useState("");
  const [doneUploadingProduct, setDoneUploadingProduct] = useState(false);

  const lastProductElementObserver = useRef();

  //Settings
  const [allowProductUpload, setAllowProductUpload] = useState(false);
  const [limitProductUpload, setLimitProductUpload] = useState(0);

  const [productAction, setProductAction] = useState();
  const [openCreateEditProduct, setOpenCreateEditProduct] = useState(false);
  const [selectedProducts, setSelectedProducts] = useState();
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [productInfoAnchorElement, setProductInfoAnchorElement] = useState(null);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [DeleteDialogMessage, setDeleteDialogMessage] = useState("");
  const [isSavingProduct, setIsSavingProduct] = useState(false);
  const [isSavingSuccess, setIsSavingSuccess] = useState(false);
  const [showDeleteProductDialog, setShowDeleteProductDialog] = useState(false);

  const downloadCsvTemplateRef = useRef();
  const deleteProductCsvTemplate = [["Product Code*"]];
  const [showDeleteProductStatusDialog, setShowDeleteProductStatusDialog] = useState(false);

  const [uploadProductCSVHeader, setUploadProductCSVHeader] = useState([]);

  const lastProductElement = useCallback(
    (node) => {
      if (isLoading) {
        return;
      }
      if (lastProductElementObserver.current) {
        lastProductElementObserver.current.disconnect();
      }
      lastProductElementObserver.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting && hasMoreProductToLoad) {
          lastProductElementObserver.current.disconnect();
          setPageNumber((prevPageNumber) => prevPageNumber + 1);
          setLoadProducts(true);
        }
      });

      if (node) {
        lastProductElementObserver.current.observe(node);
      }
    },
    [isLoading, hasMoreProductToLoad]
  );

  //temporary storage
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const menuHandleClick = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const menuHandleClose = () => {
    setMenuAnchorEl(null);
  };

  const onInputChange = (event) => {
    let file = event.target.files;
    setCsvFile(file);
  };

  function autoComplete() {
    return (
      <Autocomplete
        value={searchProductTerm}
        noOptionsText={autoCompleteSearchOptionMessage}
        onChange={(event, newValue) => {
          if (newValue == null || newValue.name === "") {
            searchProductTerm.name = "";
            return;
          }
          const searchValue =
            newValue.short_name && newValue.short_name !== "" ? newValue.short_name : newValue.name;
          setSearchProductTerm({ name: searchValue });
          setProducts([]);
          setPageNumber(1);
          setLoadProducts(true);
        }}
        filterOptions={(options, { inputValue }) => {
          if (!inputValue.trim()) return options;
          const searchTerm = inputValue.toLowerCase();
          return options.filter(
            ({ name, short_name }) =>
              name.toLowerCase().includes(searchTerm) ||
              short_name.toLowerCase().includes(searchTerm)
          );
        }}
        selectOnFocus
        clearOnBlur
        handleHomeEndKeys
        options={autoSuggestProducts}
        isOptionEqualToValue={(option, value) => true}
        getOptionLabel={(option) => {
          return option.name;
        }}
        renderOption={(props, option) => (
          <React.Fragment key={option.id}>
            <Box component="li" {...props} sx={{ width: "100%" }}>
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                <Typography variant="body1" fontWeight="bold">
                  {option.short_name && option.short_name !== "" ? option.short_name : option.name}
                </Typography>
                {option.short_name && <Typography variant="caption">{option.name}</Typography>}
              </Box>
            </Box>
            <Divider />
          </React.Fragment>
        )}
        style={{ width: "100%", paddingLeft: "8px" }}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="standard"
            InputProps={{ ...params.InputProps, disableUnderline: true }}
            onChange={(event) => {
              setSearchProductTerm({ name: event.target.value });
            }}
          />
        )}
      />
    );
  }

  function search() {
    return (
      <div
        position="static"
        style={{
          border: ".1rem solid #989898",
          borderRadius: "4px",
          margin: "2px",
        }}
      >
        <Toolbar variant="dense" style={{ padding: "0" }}>
          <Box flexGrow={1}>{autoComplete()}</Box>
          <Box>
            <IconButton
              className={classes.margin}
              size="large"
              onClick={() => {
                setProducts([]);
                setPageNumber(1);
                setLoadProducts(true);
              }}
            >
              <SearchIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </div>
    );
  }

  async function countProducts() {
    setIsLoading(true);
    const options = {
      method: "POST",
      url: "/TransactiSellerProducts/getCsvProductsCount.json",
    };
    await axios(options)
      .then((res) => {
        setIsLoading(false);
        menuHandleClose();
        let count = res.data.response.count;
        let limit = 20;
        if (!count > 0) {
          setMessageDialogMessage("No Products Found");
          setShowMessageDialog(true);
        } else {
          setShowCsvMessageDialog(true);
          const total_count = Math.ceil(count / limit);
          downloadProducts(0, count, "");
        }
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }

  async function downloadProducts(index, total_count, downloadCsvContent) {
    let percent = (index / total_count) * 100;
    setCsvDownloadPercent(percent);
    if (index < total_count) {
      await axios({
        method: "POST",
        url: "/TransactiSellerProducts/getCsvProducts.json",
        data: objectToFormData({ index: index }),
      }).then((res) => {
        let new_products = res.data.response.products_array;
        const csvData = Papa.unparse(new_products, {
          header: false,
          quotes: true,
          delimiter: ",",
        });
        if (index > 0) {
          downloadCsvContent += "\n";
        }
        downloadCsvContent += csvData;
      });
      downloadProducts(index + 20, total_count, downloadCsvContent);
    } else {
      downloadFile(downloadCsvContent, "Products");
      setCsvDownloadPercent(0);
      setShowCsvMessageDialog(false);
    }
  }

  function downloadFile(csv_data, file_name) {
    let header =
      "Code,Name,Uom,Converted To Smallest Value,Price With Tax,Price Without Tax,Short Name,Product Common Name,Description,Size,Brand,Principal,Category,Variant,Created,Modified";
    let csv = header + "\n" + csv_data;
    const url = "data:text/csv;charset=utf-8," + encodeURIComponent(csv);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${file_name}.csv`);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  function uploadProducts() {
    if (!allowProductUpload) {
      alert("You are not allowed to upload a product.");
      return;
    }
    setShowUploadProductsDialog(true);
    menuHandleClose();
  }

  function uploadProductsDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={showUploadProductsDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Upload Products</DialogTitle>
        <DialogContent>
          <Box p={1} display="flex" justifyContent="left" flexDirection="column">
            <i>
              1. All fields with asterisk are required <br />
              2. List Price with Tax must be a number
              <br />
              3. Conversion Qty in Smallest UOM must be a number
              <br />
              4. Please click
              <Button
                onClick={() => {
                  setShowUploadProductCategoriesListDialog(true);
                }}
                color="primary"
                autoFocus
              >
                <i>here</i>
              </Button>{" "}
              for the list of categories.
            </i>{" "}
            <br />
            <input accept=".csv" type="file" onChange={onInputChange} />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            style={{ marginRight: "5px" }}
            color="primary"
            onClick={() => {
              downloadTemplate("upload_products");
            }}
          >
            <FileDownloadIcon /> CSV File
          </Button>
          <Button
            variant="contained"
            component="label"
            onClick={() => {
              processUploadProductsCsv(csvFile);
            }}
          >
            <FileUploadIcon /> Upload
          </Button>
          <Button
            onClick={() => {
              setShowUploadProductsDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  function uploadProductsCategoriesListDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={showUploadProductCategoriesListDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>List of Categories</DialogTitle>
        <DialogContent>
          <List>
            {productCategoriesList.map((category, index) => (
              <ListItem key={index}>
                <ListItemText primary={category.name} />
              </ListItem>
            ))}
          </List>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowUploadProductCategoriesListDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  async function processUploadProductsCsv(csvFile) {
    try {
      const file = csvFile[0];

      if (file == undefined) {
        setShowMessageDialog(true);
        setMessageDialogMessage("File error. Please select csv file.");
        return;
      }
      if (file.type !== "text/csv") {
        setShowMessageDialog(true);
        setMessageDialogMessage("File error. File must csv.");
        return;
      }

      const csvHeader = await readCsvHeader(file);
      const missingCSVHeader = checkMissingCsvHeader(uploadProductCSVHeader.split(","), csvHeader);

      if (missingCSVHeader.length > 0) {
        setShowMessageDialog(true);
        setMessageDialogMessage(generateMissingCSVHeaderError(missingCSVHeader));
        return;
      }

      const productList = await readCsv(file);

      if (productList.length <= 0) {
        setShowMessageDialog(true);
        setMessageDialogMessage("CSV must not empty.");
        return;
      }

      const chunkedData = chunkUploadData(productList);
      const totalData = Math.ceil(productList.length / 10);

      setShowUploadProductsDialog(false);
      insertProducts(0, chunkedData, totalData);
      setShowUploadProductStatusDialog(true);
    } catch (error) {
      setShowMessageDialog(true);
      setMessageDialogMessage(error);
    }
  }
  function generateMissingCSVHeaderError(missing_header_array) {
    // Check if there are more than one element in the array
    if (missing_header_array.length > 1) {
      // Convert array elements to a string with commas
      const arrayString = missing_header_array.slice(0, -1).join(", ");

      // Create the final sentence with "and" before the last element
      return `${arrayString} and ${
        missing_header_array[missing_header_array.length - 1]
      } must be in your CSV header.`;
    } else if (missing_header_array.length === 1) {
      // If there is only one element in the array
      return `${missing_header_array[0]} must be in your CSV header.`;
    }
    return "";
  }
  function readCsvHeader(csv_file) {
   
    return new Promise((resolve, reject) => {
      var headers = [];
      Papa.parse(csv_file, {
        header: true,
        encoding: "ISO-8859-3",
        beforeFirstChunk: function (chunk) {
           
          // Remove '\r' characters from the chunk
          chunk = chunk.replace(/\r/g, "");

          // Check if '\n' is present in the chunk
          if (chunk.indexOf("\n") !== -1) {
            // Use '\n' as the line ending sequence
            headers = chunk.split("\n")[0].split(",");

            // Skip the header in the parsing process
            return chunk.substring(chunk.indexOf("\n") + 1);
          } else {
            // Use '\r\n' as the line ending sequence if '\n' is not found
            headers = chunk.split("\r\n")[0].split(",");

            // Skip the header in the parsing process
            return chunk.substring(chunk.indexOf("\r\n") + 2);
          }
        },
        step: function (row, parser) {
          parser.abort();
        },
        complete: function (results) {
          resolve(headers);
        },
        error: function (error) {
          reject(error);
        },
      });
    });
  }

  function readCsv(csvFile) {
    return new Promise((resolve, reject) => {
      var productListData = [];

      Papa.parse(csvFile, {
        header: true,
        encoding: "ISO-8859-3",
        skipEmptyLines: true,
        step: function (row) {
          if (row.errors.length == 0) {
            var productData = {};

            productData = {
              barcode: row.data.hasOwnProperty("Barcode*")
                ? row.data["Barcode*"]
                : row.data["Barcode"],
              brand: row.data.hasOwnProperty("Brand*") ? row.data["Brand*"] : row.data["Brand"],
              principal: row.data.hasOwnProperty("Manufacturer*")
                ? row.data["Manufacturer*"]
                : row.data["Manufacturer"],
              category: row.data.hasOwnProperty("Category*")
                ? row.data["Category*"]
                : row.data["Category"],
              code: row.data.hasOwnProperty("Product Code*")
                ? row.data["Product Code*"]
                : row.data["Product Code"],
              short_name: row.data.hasOwnProperty("Short Name*")
                ? row.data["Short Name*"]
                : row.data["Short Name"],
              name: row.data.hasOwnProperty("Product Name*")
                ? row.data["Product Name*"]
                : row.data["Product Name"],
              description: row.data.hasOwnProperty("Product Description*")
                ? row.data["Product Description*"]
                : row.data["Product Description"],
              variant: row.data.hasOwnProperty("Variant*")
                ? row.data["Variant*"]
                : row.data["Variant"],
              uom: row.data.hasOwnProperty("Unit of Measure*")
                ? row.data["Unit of Measure*"]
                : row.data["Unit of Measure"],
              w_tax: row.data.hasOwnProperty("List Price with Tax*")
                ? row.data["List Price with Tax*"]
                : row.data["List Price with Tax"],
              conversion_quantity: row.data.hasOwnProperty("Conversion Qty in Smallest UOM*")
                ? row.data["Conversion Qty in Smallest UOM*"]
                : row.data["Conversion Qty in Smallest UOM"],
            };

            productListData.push(productData);
          }
        },
        complete: function (results) {
          resolve(productListData);
        },
        error: function (error) {
          reject(error);
        },
      });
    });
  }
  function checkMissingCsvHeader(required_header_array, csv_header_array) {
    const required_header_array_no_asterix = required_header_array.map((item) =>
      item.replace(/\*$/, "")
    );
    const csv_header_array_no_asterix = csv_header_array.map((item) => item.replace(/\*$/, ""));

    return required_header_array_no_asterix.filter(
      (header) => !csv_header_array_no_asterix.includes(header)
    );
  }

  async function insertProducts(index, chunkedData, totalData) {
    let percent = (index / totalData) * 100;
    setCsvUploadPercent(percent);
    if (index < chunkedData.length) {
      var data = JSON.stringify(chunkedData[index]);
      await axios({
        method: "POST",
        url: "/TransactiSellerProducts/uploadProducts.json",
        data: objectToFormData({
          index: index,
          data: data,
          allowProductUpload: allowProductUpload,
          limitProductUpload: limitProductUpload,
        }),
        dataType: "json", // Add this line
      })
        .then((res) => {
          let res_status = res.data;

          setUploadStatusArray((uploadStatusArray) => [...uploadStatusArray, ...res_status]);

          //Settings Validation
          if (
            res_status[0] === "Product upload is not allowed." ||
            res_status[0] === "Product upload limit reached."
          ) {
            console.log("reach");
            return;
          } else {
            insertProducts(index + 1, chunkedData, totalData);
          }
        })
        .catch((error) => {
          setShowMessageDialog(true);
          setMessageDialogMessage(
            ` ${
              error.toJSON().message
            }. Please try again and make sure you have internet connection.`
          );
        });
    } else {
      setDoneUploadingProduct(true);
    }
  }

  function updatePrice() {
    setShowUpdatePriceDialog(true);
    menuHandleClose();
  }

  const deleteProducts = () => {
    setShowDeleteProductDialog(true);
    menuHandleClose();
  };

  function updatePriceDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={showUpdatePriceDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Update Product Prices</DialogTitle>
        <DialogContent>
          <Box p={1} display="flex" justifyContent="left" flexDirection="column">
            <i>
              1. All fields are required <br />
              2. Product code and product Uom must be existing <br />
              3. Price With Tax and Price Without Tax must be a number
            </i>{" "}
            <br />
            <input accept=".csv" type="file" onChange={onInputChange} />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button
            variant="contained"
            style={{ marginRight: "5px" }}
            color="primary"
            onClick={() => {
              downloadTemplate("update_prices");
            }}
          >
            <FileDownloadIcon /> CSV File
          </Button>
          <Button
            variant="contained"
            component="label"
            onClick={() => {
              processPriceUpdateCsv(csvFile);
            }}
          >
            <FileUploadIcon /> Upload
          </Button>
          <Button
            onClick={() => {
              setShowUpdatePriceDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  const deleteProductDialog = () => {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={showDeleteProductDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Delete Products</DialogTitle>
        <DialogContent>
          <Box p={1} display="flex" justifyContent="left" flexDirection="column">
            <i>
              1. All fields are required <br />
              2. Product code must be existing <br />
            </i>{" "}
            <br />
            <input accept=".csv" type="file" onChange={onInputChange} />
          </Box>
        </DialogContent>
        <DialogActions>
          <CSVLink
            data={deleteProductCsvTemplate}
            className={classes.csvDownloadBtn}
            ref={downloadCsvTemplateRef}
            filename={"delete_product.csv"}
          />

          <Button
            variant="contained"
            size="small"
            style={{ marginRight: "5px" }}
            color="primary"
            onClick={() => {
              downloadCsvTemplateRef.current.link.click();
            }}
          >
            <FileDownloadIcon /> CSV File
          </Button>
          <Button
            variant="contained"
            size="small"
            component="label"
            onClick={() => {
              processDeleteCsv(csvFile);
            }}
          >
            <FileUploadIcon /> Upload
          </Button>
          <Button
            onClick={() => {
              setShowDeleteProductDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  useEffect(() => {
    getProductFieldSettings();
    getProductCategoriesList();
  }, []);

  useEffect(() => {
    if (doneUploadingProduct == true && uploadStatusArray.length <= 0) {
      setMessageDialogMessage("Product uploaded successfully.");
      setShowMessageDialog(true);
      closeUploadStatusDialog();
    }
  }, [doneUploadingProduct]);

  const getProductFieldSettings = async () => {
    const options = {
      method: "POST",
      url: "/TransactiSellerProducts/getProductFieldSettings.json",
    };

    await axios(options)
      .then((res) => {
        const result = res.data.response;
        const productFields = result.join(",");

        setUploadProductCSVHeader(productFields);
      })
      .catch((error) => {
        console(error);
      });
  };

  const getProductCategoriesList = async () => {
    const options = {
      method: "POST",
      url: "/TransactiSellerProducts/getProductCategorisList.json",
    };

    await axios(options)
      .then((res) => {
        const result = res.data.categories;
        setProductCategoriesList(result);
      })
      .catch((error) => {
        console(error);
      });
  };

  function downloadTemplate(value) {
    let header = "";
    let filename = "";

    if (value === "upload_products") {
      filename = "Products masterfile.csv";
      header = uploadProductCSVHeader;
      // header = 'Product Code*,Product Name*,Short Name,Product Common Name,Description,Barcode,Principal,Brand,Category,Variant,Size,Unit of Measure*,Converted to smallest value*,List Price without Tax*,List Price with Tax*';
    } else {
      filename = "Update Prices.csv";
      header = "Product code*,Product uom*,Price with tax*,Price without tax*";
    }

    const url = "data:text/csv;charset=utf-8," + encodeURIComponent(header);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", filename);
    document.body.appendChild(link);
    link.click();
    link.remove();
  }

  const processDeleteCsv = (csvFile) => {
    let file = csvFile[0];
    let headersChecked = false;
    if (file !== undefined && file.type === "text/csv") {
      Papa.parse(file, {
        header: true,
        encoding: "UTF-8",
        skipEmptyLines: true,
        complete: function (results) {
          if (results.data.length === 0) {
            alert("CSV is empty.");
            return;
          }

          if (!headersChecked) {
            let keys = [];
            Object.keys(results.data[0]).forEach((value) => {
              keys.push(value.toLowerCase());
            });

            if (keys.includes("product code*")) {
              headersChecked = true;
            } else {
              alert("File Error. Please Check your headers");
            }
          }

          if (headersChecked) {
            let chunkedData = chunkUploadData(results.data);
            let totalData = Math.ceil(results.data.length / 10);

            if (chunkedData.length > 0) {
              setShowDeleteProductDialog(false);
              uploadDeleteProduct(0, chunkedData, totalData);
              setShowDeleteProductStatusDialog(true);
            } else {
              alert("No data to upload");
            }
          }
        },
      });
    } else {
      alert("File error. Please check your file or if a file was selected.");
    }
  };

  function processPriceUpdateCsv(csvFile) {
    let file = csvFile[0];
    let headersChecked = false;

    let header_errors = 0;
    const default_csv_header = [
      "product code*",
      "product uom*",
      "price with tax*",
      "price without tax*",
    ];

    if (file === undefined) {
      setShowMessageDialog(true);
      setMessageDialogMessage("Please select CSV File.");
      return;
    }

    if (file !== undefined && file.type === "text/csv") {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        complete: function (results) {
          // Validate if empty CSV
          if (results.data.length === 0) {
            setShowMessageDialog(true);
            setMessageDialogMessage("Please fill in the CSV file with data before proceeding.");
            return;
          }

          // Validate Header
          Object.keys(results.data[0]).forEach((value) => {
            let header = value.toLowerCase();

            if (!default_csv_header.includes(header.toLowerCase())) {
              // Add parentheses after toLowerCase
              header_errors++;
              setShowMessageDialog(true);
              setMessageDialogMessage("File Error. Please Check your header `" + header + "`");
              return;
            }
          });

          headersChecked = header_errors === 0 ? true : false;

          if (headersChecked) {
            let chunkedData = chunkUploadData(results.data);
            if (chunkedData.length > 0) {
              setShowUpdatePriceDialog(false);
              updateUploadedProductsPrice(0, chunkedData);
              setShowUpdatePriceStatusDialog(true);
            } else {
              alert("No data to upload");
            }
          }
        },
      });
    } else {
      alert("File error. Please check your file or if a file was selected.");
    }
  }

  function chunkUploadData(results) {
    let chunkedData = [];
    let dataArray = [];
    for (let i = 0; i < results.length; i++) {
      if (dataArray.length === 10) {
        chunkedData.push(dataArray);
        dataArray = [];
      }

      dataArray.push(results[i]);

      if (i === results.length - 1) {
        chunkedData.push(dataArray);
        dataArray = [];
      }
    }
    return chunkedData;
  }

  async function updateUploadedProductsPrice(index, chunkedData) {
    if (index < chunkedData.length) {
      var data = JSON.stringify(chunkedData[index]);
      await axios({
        method: "POST",
        url: "/TransactiSellerProducts/updateProductPrices.json",
        data: objectToFormData({ index: index, data: data }),
      }).then((res) => {
        let res_status = res.data;
        setUploadStatusArray((uploadStatusArray) => [...uploadStatusArray, ...res_status]);
      });
      updateUploadedProductsPrice(index + 1, chunkedData);
    }
  }

  async function uploadDeleteProduct(index, chunkedData, totalData) {
    let percent = (index / totalData) * 100;
    setCsvUploadPercent(percent);

    if (index < totalData) {
      var data = JSON.stringify(chunkedData[index]);
      await axios({
        method: "POST",
        url: "/TransactiSellerProducts/uploadDeleteProduct.json",
        data: objectToFormData({ index: index, data: data }),
      }).then((res) => {
        let res_status = res.data;
        setUploadStatusArray((uploadStatusArray) => [...uploadStatusArray, ...res_status]);
        uploadDeleteProduct(index + 1, chunkedData, totalData);
      });
    }

    setProducts([]);
    setLoadProducts(true);
  }

  function uploadProductsStatusDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={showUploadProductStatusDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Upload Products</DialogTitle>
        <DialogContent>
          <LinearProgress sx={{ height: 10 }} variant="determinate" value={csvUploadPercent} />
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 500 }} aria-label="caption table" id="status_tbl">
              <TableHead>
                <TableRow>
                  <TableCell align="left">
                    <b>Line</b>
                  </TableCell>
                  <TableCell>
                    <b>Message</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {uploadStatusArray.map((value, index) => (
                  <TableRow key={index}>
                    <TableCell align="left" component="th" scope="row">
                      <b>{index + 1}</b>
                    </TableCell>
                    <TableCell>{value}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              closeUploadStatusDialog();
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  function updatePriceStatusDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={showUpdatePriceStatusDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Update Product Prices</DialogTitle>
        <DialogContent>
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 500 }} aria-label="caption table" id="status_tbl">
              <TableHead>
                <TableRow>
                  <TableCell align="left">
                    <b>Line</b>
                  </TableCell>
                  <TableCell>
                    <b>Message</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {uploadStatusArray.map((value, index) => (
                  <TableRow key={index}>
                    <TableCell align="left" component="th" scope="row">
                      <b>{index + 1}</b>
                    </TableCell>
                    <TableCell>{value}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              closeUploadStatusDialog();
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  function deleteProductStatusDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={showDeleteProductStatusDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle>Upload Delete Products</DialogTitle>
        <DialogContent>
          <LinearProgress sx={{ height: 10 }} variant="determinate" value={csvUploadPercent} />
          <TableContainer component={Paper}>
            <Table sx={{ minWidth: 500 }} aria-label="caption table" id="status_tbl">
              <TableHead>
                <TableRow>
                  <TableCell align="left">
                    <b>Line</b>
                  </TableCell>
                  <TableCell>
                    <b>Message</b>
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {uploadStatusArray.map((value, index) => (
                  <TableRow key={index}>
                    <TableCell align="left" component="th" scope="row">
                      <b>{index + 1}</b>
                    </TableCell>
                    <TableCell>{value}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              closeUploadStatusDialog();
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  function closeUploadStatusDialog() {
    setPageNumber(1);
    setProducts([]);
    setLoadProducts(true);
    setShowUpdatePriceStatusDialog(false);
    setShowUploadProductStatusDialog(false);
    setShowDeleteProductStatusDialog(false);
    setUploadStatusArray([]);
    setCsvUploadPercent(0);
  }

  function displayUnit(unit) {
    return (
      <Box display="flex" justifyContent="flex-end">
        <Box
          // p={1}
          display="flex"
          justifyContent="center"
          flexDirection="column"
        >
          <Typography variant="h3" component="span" fontWeight={600} fontSize="16px">
            <Typography component="span" variant="body1" color="success.main" fontWeight={600}>
              ₱
              {Number(unit.price_with_tax).toLocaleString(undefined, {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}{" "}
            </Typography>
            /{" "}
            <Typography component="span" variant="body1">
              {unit.uom}
            </Typography>
          </Typography>
        </Box>
      </Box>
    );
  }

  function productElement(product) {
    return (
      <Grid container spacing={1}>
        {/* Product Info */}
        <Grid item xs={12} lg={12}>
          <Box display="flex" flexDirection="column">
            <Typography variant="h7" fontWeight={600}>
              {product.name}
            </Typography>
            {product.short_name && <Typography variant="caption">{product.short_name}</Typography>}
            <Typography variant="caption">{product.brand}</Typography>
            <Typography variant="caption">{product.code}</Typography>
          </Box>
        </Grid>

        {/* Product UOM */}
        <Grid item xs={11} lg={11}>
          <Box>
            <IconButton
              size="large"
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                zIndex: 10,
              }}
              onClick={(event) => {
                setSelectedProduct(product);
                setProductInfoAnchorElement(event.currentTarget);
              }}
            >
              <MoreVertIcon />
            </IconButton>
          </Box>
          <Box>
            {product.Units.map((unit) => (
              <React.Fragment key={unit.id}>{displayUnit(unit)}</React.Fragment>
            ))}
          </Box>
        </Grid>
        <Grid item xs={1} lg={1}>
          <IconButton
            size="large"
            style={{
              position: "absolute",
              top: 0,
              right: 0,
              zIndex: 10,
            }}
            onClick={(event) => {
              setSelectedProduct(product);
              setProductInfoAnchorElement(event.currentTarget);
            }}
          >
            <MoreVertIcon />
          </IconButton>
        </Grid>
      </Grid>
    );
  }

  function productLists() {
    return (
      <>
        {products.map((product, index) =>
          products.length === index + 1 ? (
            <React.Fragment key={index + product.id + product.name}>
              <ListItem ref={lastProductElement} key={index + product.id + product.name} divider>
                {productElement(product)}
              </ListItem>
            </React.Fragment>
          ) : (
            <React.Fragment key={index + product.id + product.name}>
              <ListItem
                key={index + product.id + product.name}
                divider
                style={{ boxShadow: "none !important" }}
              >
                {productElement(product)}
              </ListItem>
            </React.Fragment>
          )
        )}
      </>
    );
  }

  function messageDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={showMessageDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Message"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {messageDialogMessage}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setShowMessageDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  function csvDownloadMessageDialog() {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"md"}
        open={showCsvMessageDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">CSV Download</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            <LinearProgress variant="determinate" value={csvDownloadPercent} />
          </DialogContentText>
        </DialogContent>
      </Dialog>
    );
  }

  useEffect(() => {
    productSettings();
  }, []);

  async function productSettings() {
    const options = {
      method: "POST",
      url: "/TransactiLiteGeneralSettings/productSettings.json",
    };

    await axios(options).then((res) => {
      if (res.data.allow_product_upload === "1") {
        setAllowProductUpload(true);
      }
      setLimitProductUpload(parseInt(res.data.limit_product_upload));
    });
  }

  useEffect(() => {
    if (!loadProducts) {
      return;
    }
    setAppBarWidth(elementRef.current.getBoundingClientRect().width);
    fetchProducts(searchProductTerm.name);
  }, [loadProducts, searchProductTerm.name]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    function fetchAutoSuggestProducts(searchString) {
      const loadProducts = async () => {
        setAutoCompleteSearchOptionMessage("Searching");

        const options = {
          method: "POST",
          url: "/TransactiSellerProducts/getProductsForAutoSuggest.json",
          data: objectToFormData({ search_term: searchString }),
        };
        await axios(options).then((res) => {
          const products = res.data.products;
          if (products.length <= 0) {
            setAutoCompleteSearchOptionMessage("No record found.");
            setAutoSuggestProducts([]);
          } else {
            setAutoSuggestProducts(products);
          }
        });
      };
      loadProducts();
    }

    if (searchProductTerm == null) {
      fetchAutoSuggestProducts("");
    } else {
      fetchAutoSuggestProducts(searchProductTerm.name);
    }
  }, [searchProductTerm]);

  function fetchProducts(searchTerm) {
    setIsLoading(true);
    setHasErrorFetchingProducts(false);

    const options = {
      method: "POST",
      url: "/TransactiSellerProducts/getTransactiSellerProducts.json",
      data: objectToFormData({
        search_term: searchTerm,
        page_number: pageNumber,
      }),
    };
    axios(options)
      .then((res) => {
        setIsLoading(false);
        setLoadProducts(false);

        const isSuccess = res.data.response.is_success;
        if (!isSuccess) {
          setMessageDialogMessage(res.data.response.message);
          setShowMessageDialog(true);
          setHasErrorFetchingProducts(true);
        }

        const productsFromServer = res.data.response.products;
        setHasMoreProductToLoad(productsFromServer.length > 0);
        setProducts(products.concat(productsFromServer));
      })
      .catch((error) => {
        setIsLoading(false);
      });
  }

  const objectToFormData = (object) =>
    Object.keys(object).reduce((formData, key) => {
      formData.append(key, object[key]);
      return formData;
    }, new FormData());
  const progressDialog = () => {
    return (
      <Dialog fullWidth={true} maxWidth={"lg"} open={isSavingProduct} onClose={() => {}}>
        <DialogContent>
          <DialogContentText>Please wait...</DialogContentText>
          <LinearProgress color="secondary" />
        </DialogContent>
      </Dialog>
    );
  };

  const deleteProduct = () => {
    setShowDeleteDialog(false);
    setIsSavingProduct(true);

    const options = {
      method: "POST",
      url: "/TransactiSellerProducts/deleteProduct.json",
      data: objectToFormData({
        product_code: selectedProduct.code,
        product_name: selectedProduct.name,
      }),
    };

    axios(options)
      .then((response) => {
        const is_success = response.data.response.is_success;

        setSearchProductTerm({ name: "" });
        setProducts([]);
        setPageNumber(1);
        setLoadProducts(true);
        setIsSavingSuccess(is_success);
        setIsSavingProduct(false);
        setMessageDialogMessage(response.data.response.message);
        setShowMessageDialog(true);
      })
      .catch((error) => {
        setProducts([]);
        setLoadProducts(true);
        setIsSavingSuccess(false);
        setIsSavingProduct(false);
        setMessageDialogMessage(error.message);
        setShowMessageDialog(true);
      });
  };

  const deleteDialog = () => {
    return (
      <Dialog
        fullWidth={true}
        maxWidth={"sm"}
        open={showDeleteDialog}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">{"Delete Product"}</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">{DeleteDialogMessage}</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              deleteProduct();
            }}
          >
            {" "}
            <Typography color="error">Delete</Typography>
          </Button>
          <Button
            onClick={() => {
              setShowDeleteDialog(false);
            }}
            color="primary"
            autoFocus
          >
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    );
  };

  function searchByDropdownMenu() {
    return (
      <Menu
        id="simple-menu"
        anchorEl={productInfoAnchorElement}
        keepMounted
        open={Boolean(productInfoAnchorElement)}
        onClose={() => {
          setProductInfoAnchorElement(null);
        }}
      >
        <MenuItem
          onClick={() => {
            setProductAction("update");
            setOpenCreateEditProduct(true);
            setSelectedProducts(selectedProduct);
            setProductInfoAnchorElement(null);
          }}
        >
          <EditIcon /> Edit
        </MenuItem>
        <MenuItem
          onClick={() => {
            setShowDeleteDialog(true);
            setSelectedProducts(selectedProduct);
            setProductInfoAnchorElement(null);
            setDeleteDialogMessage("Delete Product " + selectedProduct.name);
          }}
        >
          <DeleteIcon /> Delete
        </MenuItem>
      </Menu>
    );
  }

  useEffect(() => {}, [openCreateEditProduct, selectedProducts]);

  return (
    <React.Fragment>
      <div>
        <CssBaseline />
        <AppBar
          position="fixed"
          className={classes.appBarTop}
          aria-haspopup="true"
          onClick={handleClick}
          ref={elementRef}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={props.handleDrawerToggle}
              className={classes.menuButton}
              size="large"
            >
              <MenuIcon />
            </IconButton>
            <Typography variant="h6" noWrap>
              Products
            </Typography>
            <div style={{ flex: 1 }}></div>
            <IconButton className={classes.margin} onClick={menuHandleClick} edge="end">
              <MoreVertIcon />
            </IconButton>
            <Menu
              id="simple-menu"
              open={openMenu}
              anchorEl={menuAnchorEl}
              onClose={() => {
                setMenuAnchorEl(null);
              }}
            >
              <MenuItem disabled={allowProductUpload ? false : true} onClick={uploadProducts}>
                Upload Products
              </MenuItem>
              <MenuItem onClick={countProducts}>Download Products</MenuItem>
              <MenuItem onClick={updatePrice}>Update Price</MenuItem>
              <MenuItem onClick={deleteProducts}>Delete Products</MenuItem>
            </Menu>
          </Toolbar>
          <Box sx={{ backgroundColor: "white" }}>
            {search()}
            {isLoading ? (
              <LinearProgress
                color="secondary"
                style={{ marginLeft: ".1rem", marginRight: ".1rem" }}
              />
            ) : (
              ""
            )}
          </Box>
        </AppBar>
      </div>
      {!hasErrorFetchingProducts && (
        <Box sx={{ marginTop: "60px" }}>
          <CssBaseline />
          {productLists()}
          {searchByDropdownMenu()}
        </Box>
      )}
      <div className={classes.appBarSpacer}></div>
      <AppBar position="fixed" color="primary" className={classes.appBarBottom}>
        {loadProducts ? (
          <LinearProgress color="secondary" style={{ marginLeft: ".1rem", marginRight: ".1rem" }} />
        ) : (
          ""
        )}
      </AppBar>
      <AppBar
        position="fixed"
        style={{ background: "transparent", boxShadow: "none" }}
        className={classes.appBarBottom}
      >
        <Toolbar>
          <div className={classes.grow} />

          <Fab
            variant="extended"
            size="medium"
            color="primary"
            aria-label="add"
            className={classes.margin}
            onClick={() => {
              setProductAction("add");
              setOpenCreateEditProduct(true);
            }}
          >
            <AddIcon className={classes.extendedIcon} />
            Add Product
          </Fab>
        </Toolbar>
      </AppBar>

      {openCreateEditProduct ? (
        <CreateEditProduct
          selectedProducts={selectedProducts}
          setSelectedProducts={setSelectedProducts}
          openCreateEditProduct={openCreateEditProduct}
          setOpenCreateEditProduct={setOpenCreateEditProduct}
          productAction={productAction}
          setProductAction={setProductAction}
          loadProducts={loadProducts}
          setLoadProducts={setLoadProducts}
          setProductsTable={setProducts}
          setPageNumber={setPageNumber}
        />
      ) : (
        ""
      )}

      <StyledEngineProvider injectFirst>
        <ThemeProvider theme={materialTheme}> {progressDialog()}</ThemeProvider>
        <ThemeProvider theme={materialTheme}> {deleteProductDialog()}</ThemeProvider>
        <ThemeProvider theme={materialTheme}> {deleteDialog()}</ThemeProvider>
        <ThemeProvider theme={materialTheme}> {messageDialog()}</ThemeProvider>
        <ThemeProvider theme={materialTheme}> {csvDownloadMessageDialog()}</ThemeProvider>
        <ThemeProvider theme={materialTheme}> {uploadProductsDialog()}</ThemeProvider>
        <ThemeProvider theme={materialTheme}> {updatePriceDialog()}</ThemeProvider>
        <ThemeProvider theme={materialTheme}> {updatePriceStatusDialog()}</ThemeProvider>
        <ThemeProvider theme={materialTheme}> {deleteProductStatusDialog()}</ThemeProvider>
        <ThemeProvider theme={materialTheme}> {uploadProductsStatusDialog()}</ThemeProvider>
        <ThemeProvider theme={materialTheme}> {uploadProductsCategoriesListDialog()}</ThemeProvider>
      </StyledEngineProvider>
    </React.Fragment>
  );
}
